import { isValidPhoneNumber } from 'react-phone-number-input/max';
import { PublicVisibleType, PublicVisibleTypeMap } from '../../../types/form';
import { allBuiltinUserValuesForActions } from '../../components/TriggerPage/NewTriggerForm';
import { isEmail } from './formHelper.validators';

// HACK, this is just a workaround to send `id:null:null` if id avaliable due to user source changes is not fully trackable, currently
const parseSerializedValueFromUserFormValueToPostTicketData = (value: string) => {
    if (!value || typeof value !== 'string') return null;
    return controlledSerializedValue(value.split('|')[0], true);
};
export const controlledUserFormValueToPostTicketData = (value: string) => {
    if (!value || typeof value !== 'string') return null;
    const userValueList = value.split(',');
    if (userValueList.length > 1)
        return userValueList
            .map(parseSerializedValueFromUserFormValueToPostTicketData)
            .filter((value) => value)
            .join(',');
    return parseSerializedValueFromUserFormValueToPostTicketData(userValueList[0]);
};

export const controlledUserFormValue = (value: string) => {
    if (!value || typeof value !== 'string') return null;
    const userValueList = value.split(',');
    if (userValueList.length > 1)
        return userValueList
            .map((v) => parseSerializedValueFromUserFormValue(v))
            .filter((value) => value)
            .join(',');
    return parseSerializedValueFromUserFormValue(userValueList[0]);
};

// to convert email||phone-number input to serializedValue i.e, `null:email:null`
export const controlledSerializedValue = (serializedValue: string, updateTicket = false) => {
    if (!serializedValue || typeof serializedValue !== 'string') return null;
    if (allBuiltinUserValuesForActions.includes(serializedValue)) return serializedValue;
    const splittedValue = serializedValue.split(':');
    const [firstItem, email, phone] = splittedValue;
    if (!email || !phone) {
        if (isValidPhoneNumber(firstItem)) return `null:null:${firstItem}`;
        if (isEmail(firstItem)) return `null:${firstItem}:null`;
    }
    return !updateTicket ? serializedValue : `${firstItem}:null:null`; // HACK, this is just a workaround to send `id:null:null` if id avaliable due to user source changes is not fully trackable, currently
};
export const parseMentionInfoFromUserFormValue = (value: string) => {
    if (!value || typeof value !== 'string') return false;
    return value.split('|')[2] === 'mention';
};

export const parseSerializedValueFromUserFormValue = (value: string) => {
    if (!value || typeof value !== 'string') return null;
    return controlledSerializedValue(value.split('|')[0]);
};
export const parseUserIdFromSerializedValue = (value: string): number => {
    if (!value) return null;
    const possibleUserId = value.split(':')[0];
    if (!possibleUserId) return null;
    if (possibleUserId === 'null') return null;
    return +possibleUserId;
};
export const parseEmailFromSerializedValue = (value: string) => {
    if (!value) return null;
    const possibleEmail = value.split(':')[1];
    if (!possibleEmail) return null;
    if (possibleEmail === 'null') return null;
    return possibleEmail;
};
export const parseFullNameFromSerializedUntrustedEndUserValue = (value: string) => {
    if (!value) return null;
    const possibleFullName = value.split(':')[0];
    if (!possibleFullName) return null;
    if (possibleFullName === 'null') return null;
    return possibleFullName;
};
export const parsePhoneNumberFromSerializedValue = (value: string) => {
    if (!value) return null;
    const possiblePhoneNumber = value.split(':')[2];
    if (!possiblePhoneNumber) return null;
    if (possiblePhoneNumber === 'null') return null;
    return possiblePhoneNumber;
};
export const parseUserFriendlyValueFromUserValue = (value: string) => value.split('|')[1];

export const parseUserIdFromUserValue = (value: string) => {
    if (allBuiltinUserValuesForActions.includes(value)) return value;
    return parseUserIdFromSerializedValue(value?.split('|')[0]);
};
export const parseMultipleUserIdFromUserValue = (value: string) => {
    if (!value || typeof value !== 'string') return null;
    const userValueList = value.split(',');
    if (userValueList.length > 1)
        return userValueList
            .map((v) => {
                return parseUserIdFromUserValue(v);
            })
            .filter((value) => value)
            .join(',');
    return parseUserIdFromUserValue(value);
};
export const parseFullNameFromUserFriendlyValue = (value: string) => {
    if (!value) return null;
    const possibleFullName = value.split('(');
    if (possibleFullName.length < 2) return null;
    return possibleFullName[0];
};
export const parseEmailFromUserFriendlyValue = (value: string) => {
    if (!value) return null;
    const possibleEmail = value.split('(');
    if (possibleEmail.length < 2) return null;
    return possibleEmail[1].split(')')[0];
};

export const publicVisibleToBooleanConverter = (publicVisible: PublicVisibleType) =>
    publicVisible === PublicVisibleTypeMap.public;
